var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav-main",attrs:{"id":"menu","role":"navigation"}},[_c('ul',{staticClass:"nav nav-main"},_vm._l((_vm.list),function(item){return _c('item',{key:item.id,attrs:{"item":item},on:{"collapseSidebar":_vm.closeSidebar}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }